/* eslint-disable */
export enum AvailabilityStatus {
  AVAILABLE = 'available',
  BLOCKED = 'blocked',
  OCCUPIED = 'occupied'
}

